export default __webpack_public_path__ + "static/media/File No.1.17011444.pdf";